import { render } from "./create-company.vue?vue&type=template&id=3c24bd58&scoped=true"
import script from "./create-company.vue?vue&type=script&lang=js"
export * from "./create-company.vue?vue&type=script&lang=js"

import "./create-company.vue?vue&type=style&index=0&id=3c24bd58&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c24bd58"]])

export default __exports__